import { defineStore, acceptHMRUpdate } from 'pinia'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useApprovalQuery } from 'src/composables/approval/query/useApprovalQuery'
import { getApprovalActiveIcon, isApprovalOverdue } from 'src/services/helpers/approval.helper'
import { useUtcToday } from 'src/composables/app/system/useUtcToday'

export const useApprovalStore = defineStore('approval', () => {
  const route = useRoute()
  const router = useRouter()

  const approvalId = computed(() => route.query.approvalId)

  const { approval, isApprovalLoading, isApprovalRefetching, approvalError, refetchApproval } =
    useApprovalQuery(approvalId)
  const utcToday = useUtcToday()

  // Computed - used in multiple components
  const isActive = computed(() => approval.value?.active || false)
  const statusIcon = computed(() => {
    if (!approval.value) return 'badge-check'
    return getApprovalActiveIcon(approval.value.active)
  })
  const isOverdue = computed(() => {
    if (!approval.value) return false
    return isApprovalOverdue(approval.value, utcToday.value)
  })

  function closeModal() {
    const newQuery = { ...route.query }
    delete newQuery.approvalId
    router.replace({ query: newQuery })
  }

  return {
    // State
    approvalId,
    isModalOpen: computed(() => !!approvalId.value),

    // Data
    approval,
    isApprovalLoading,
    isApprovalRefetching,
    approvalError,

    // Computed (used in multiple components)
    isActive,
    statusIcon,
    isOverdue,

    // Actions
    closeModal,
    refetchApproval,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useApprovalStore, import.meta.hot))
}
